import { motion } from 'framer-motion'

import arbventurelogo from '../../../assets/images/homepage/company/arbventurelogo.webp'
import arzoologo from '../../../assets/images/homepage/company/arzoologo.webp'
import tatvacarelogo from '../../../assets/images/homepage/company/tatvacarelogo.webp'
import cryptonarylogo from '../../../assets/images/homepage/company/cryptonarylogo.webp'
import zyduslogo from '../../../assets/images/homepage/company/zyduslogo.webp'
import rabbitxlogo from '../../../assets/images/homepage/company/rabbitxlogo.webp'
import gostortlogo from '../../../assets/images/homepage/company/gostortlogo.webp'
import goodfliplogo from '../../../assets/images/homepage/company/goodfliplogo.webp'

type Props = {
  fadeUp?: any
}

const logos = [
  { src: arbventurelogo, alt: 'arbventurelogo', width: 'w-28' },
  { src: arzoologo, alt: 'arzoologo', width: 'w-24' },
  { src: tatvacarelogo, alt: 'tatvacarelogo', width: 'w-24' },
  { src: cryptonarylogo, alt: 'cryptonarylogo', width: 'w-28' },
  { src: zyduslogo, alt: 'zyduslogo', width: 'w-20' },
  { src: rabbitxlogo, alt: 'rabbitxlogo', width: 'w-24' },
  { src: gostortlogo, alt: 'gostortlogo', width: 'w-20' },
  { src: goodfliplogo, alt: 'goodfliplogo', width: 'w-24' },
]

const CompanyName = ({ fadeUp }: Props) => {
  return (
    <>
      {/* INLINE CSS */}
      <style>
        {`
          .marquee-wrapper {
            overflow: hidden;
            width: 100%;
            position: relative;
          }

          .marquee-track {
            display: flex;
            align-items: center;
            width: max-content;
            animation: marqueeMove 22s linear infinite;
            will-change: transform;
          }

          @keyframes marqueeMove {
            0% {
              transform: translate3d(0, 0, 0);
            }

            100% {
              transform: translate3d(-33.333%, 0, 0);
            }
          }
        `}
      </style>

      <div className="w-full overflow-hidden my-5 sm:my-6 md:my-6 lg:my-8 xl:my-10 2xl:my-16">

        {/* DESKTOP */}
        <motion.div
          {...fadeUp}
          className="hidden lg:flex px-10 md:px-15 lg:px-10 2xl:px-20 items-center justify-between gap-10 md:gap-15 lg:gap-12 2xl:gap-10"
        >

          <img src={arbventurelogo} alt="arbventurelogo" className="w-30 md:w-25 lg:w-20 xl:w-25 2xl:w-30" />
          <img src={arzoologo} alt="arzoologo" className="w-25 md:w-17 lg:w-25 xl:w-20 2xl:w-25" />
          <img src={tatvacarelogo} alt="tatvacarelogo" className="w-25 md:w-25 lg:w-20 xl:w-25 2xl:w-30" />
          <img src={cryptonarylogo} alt="cryptonarylogo" className="w-25 md:w-25 lg:w-20 xl:w-25 2xl:w-40" />
          <img src={zyduslogo} alt="zyduslogo" className="w-25 md:w-20 lg:w-15 xl:w-20 2xl:w-25" />
          <img src={rabbitxlogo} alt="rabbitxlogo" className="w-25 md:w-25 lg:w-20 xl:w-25 2xl:w-30" />
          <img src={gostortlogo} alt="gostortlogo" className="w-25 md:w-20 lg:w-15 xl:w-20 2xl:w-25" />
          <img src={goodfliplogo} alt="goodfliplogo" className="w-25 md:w-20 lg:w-20 xl:w-25 2xl:w-30" />

        </motion.div>

        {/* MOBILE + TABLET */}
        <div className="marquee-wrapper flex lg:hidden">

          <div className="marquee-track">

            {/* REPEAT 3 TIMES FOR PERFECT LOOP */}
            {[...logos, ...logos, ...logos].map((logo, index) => (
              <div
                key={index}
                className="flex items-center justify-center px-6 shrink-0"
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className={`${logo.width} object-contain`}
                />
              </div>
            ))}

          </div>
        </div>
      </div>
    </>
  )
}

export default CompanyName